import { labelSizes, widths } from '../commonDisplayOptions';
import { fieldNames } from '../fields';

export const dataModel = {
    component: String(),
    id: String(),
    label: String(),
    labelSize: labelSizes,
    width: widths,
    rows: Number(),
    rowsMax: Number(),
    placeholder: String(),
    required: Boolean(),
    helperText: String(),
    value: String(),
    reportingLabel: String(),
    validations: {
        maxLength: {
            val: String(),
            message: String()
        }
    }
};

export const defaults = {
    component: fieldNames.paragraph,
    labelSize: labelSizes.sm.value,
    width: widths['100'].value,
    rows: 2,
    rowsMax: 10
};
